export default "__VITE_ASSET__sJPXL83i__"